{
    "serviceTableMeta": {
        "name": "JobOrderService",
        "columns": [
        {
            "fieldName": "metadata.serviceName",
            "displayName": "Service",
            "dataType": "STRING"
        },
        {
            "fieldName": "metadata.vendorName",
            "displayName": "Vendor",
            "dataType": "STRING"
        },
        {
            "fieldName": "metadata.equipmentDetails",
            "displayName": "Equipments",
            "dataType": "STRING",
            "styleConfig": {
                "type": "multi-tag",
                "multiTagConfig": {
                    "labelKey": "name",
                    "backgroundColor": "var(--gray-100)",
                    "color": "var(--gray-warm-900, #1C1917)"
                }
            }

        },
        {
            "fieldName": "attributes",
            "displayName": "Attributes",
            "dataType": "STRING",
            "styleConfig": {
                "type": "multi-tag",
                "multiTagConfig": {
                    "labelKey": "displayValue"
                }
            }
        }
    ]
  }
}